/**
 * ServiceStats.device_type is set by the backend from detect_device_type() on ingest.
 * UI should not re-implement platform heuristics — only read this field.
 *
 * - gateway → Gateways page
 * - anything else (onpremise / missing) → Dashboard “on-prem” views
 */

export const GATEWAY_OFFLINE_MINUTES = 10;
export const GATEWAY_WARNING_MINUTES = 5;

export function isGatewayDeviceType(deviceType?: string | null): boolean {
  return deviceType === 'gateway';
}

export function isOnPremiseDeviceType(deviceType?: string | null): boolean {
  return !isGatewayDeviceType(deviceType);
}
